import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('moduleTask', 'moduleTasks');

const customActions = {
  async LOAD_moduleTasks({ commit, rootGetters }, processId) {
    const data = await odata.o(rootGetters)
      .get('moduleTasks')
      .query({ $filter: `IsDeleted eq false AND ProcessId eq ${processId}` });
    commit('SET_moduleTasks', data);

    return data;
  },
};

export default { ...actions, ...customActions };
